import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RtrugsShell } from "@rtrugs/ui";

const root = document.getElementById("root");
if (root === null) throw new Error("缺少界面根节点。 ");
const environment: unknown = import.meta.env;
const configuredApiBaseUrl =
  typeof environment === "object" &&
  environment !== null &&
  "VITE_API_BASE_URL" in environment &&
  typeof environment.VITE_API_BASE_URL === "string"
    ? environment.VITE_API_BASE_URL
    : undefined;

createRoot(root).render(
  <StrictMode>
    <RtrugsShell
      apiBaseUrl={configuredApiBaseUrl ?? "http://127.0.0.1:3000/api/v1"}
      surface="web"
    />
  </StrictMode>,
);
